import {
  type Dispatch,
  type FC,
  memo,
  type SetStateAction,
  useEffect,
} from 'react';
import { motion } from 'framer-motion';

import ProductOfDayItem from '@/components/ProductOfDayItem/ProductOfDayItem';
import { selectProductOfDayContracts } from '@/redux/selectors/contractSelectors';
import { useAppSelector } from '@/redux/store';

import { ContractItemAnimationWrapper } from '../ContractItemAnimationWrapper/ContractItemAnimationWrapper';

interface DailyContractsProps {
  isUninitialized: boolean;
  setDailyContractsIsVisit: Dispatch<SetStateAction<boolean>>;
}

const DailyContracts: FC<DailyContractsProps> = memo(
  ({ isUninitialized, setDailyContractsIsVisit }) => {
    const productsOfDayContracts = useAppSelector(selectProductOfDayContracts);

    useEffect(() => {
      setDailyContractsIsVisit(true);
      localStorage.setItem(
        'last-daily-contracts-visit',
        new Date().toISOString(),
      );
    }, []);

    return (
      <motion.div
        layout
        key="daily-contract-list"
        className="px-8 md-h:pt-4 pt-6 h-[9.5rem] md-h:h-[9rem] overflow-y-hidden flex gap-8 w-max md-h:mb-3 mb-6"
        animate={{ opacity: 1 }}
        initial={{ opacity: 0 }}
        exit={{ opacity: 0 }}
      >
        {productsOfDayContracts?.map((product, index) => (
          <ContractItemAnimationWrapper
            key={product.id === '-' ? index : product.id}
            isUninitialized={isUninitialized}
          >
            <ProductOfDayItem
              product={product}
              isUninitialized={isUninitialized}
            />
          </ContractItemAnimationWrapper>
        ))}
      </motion.div>
    );
  },
);

export default DailyContracts;
